// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cont[data-v-00f57bc0]{position:absolute;width:100%;text-align:center}@media only screen and (max-width:576px){.cont[data-v-00f57bc0]{text-align:left}}", ""]);
// Exports
module.exports = exports;
